import { RequestError } from '../../../utils/request';

/** Steps that need the network fail fast instead of waiting for a doomed request. */
export function assertOnline() {
  if (globalThis.navigator?.onLine === false) {
    throw new RequestError('network', 'This step requires an internet connection');
  }
}

export const isConnectionError = (error) => ['network', 'timeout'].includes(error?.kind);
